import { render } from "./designDeptPreview.vue?vue&type=template&id=5a1dde42"
import script from "./designDeptPreview.vue?vue&type=script&lang=js"
export * from "./designDeptPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__